var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(_vm.tooltipContent())?_c(_vm.tooltipContent(),{tag:"component",attrs:{"content":_vm.content,"label":_vm.label}}):_c('div',{staticClass:"missing-tooltip-content"},[_vm._v("Missing Content")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }